<template>
  <asc-page-header class="asc-report-header-template">
    <template v-if="!reportDataLoading" slot="pageTitle">
      <div class="asc-report-header-template--header">
        <div class="asc-report-header-template--header-title">
          <asc-page-title :title="getReportHeader"></asc-page-title>
        </div>
        <div class="asc-report-header-template--header-dropdown">
          <asc-autocomplete-selector
            :value="reportId"
            :items="getReportTimeLineItems"
            disable-select-all
            class="asc-report-time-line-options"
            placeholder="Select Report Time Line"
            no-array
            dense
            drop-down-size-matches
            fixed-position
            :sort-items="false"
            @input="onReportTimeLineChange"
          ></asc-autocomplete-selector>
        </div>
      </div>
    </template>
    <template v-if="!reportDataLoading" #pageActions>
      <asc-previous-next-buttons
        :on-previous-report="onPreviousReport"
        :previous-disabled="previousDisabled"
        :on-next-report="onNextReport"
        :next-disabled="nextDisabled"
      ></asc-previous-next-buttons>
    </template>
  </asc-page-header>
</template>

<script>
import AscPageHeader from '@/components/atoms/AscPageHeader'
import AscPageTitle from '@/components/atoms/AscPageTitle'
import AscAutocompleteSelector from '@/components/molecules/AscAutocompleteSelector'
import AscPreviousNextButtons from '@/components/molecules/AscPreviousNextButtons'
import { getDateFormatted } from '@/utilities/dates'

export default {
  name: 'AscReportHeaderTemplate',

  components: {
    AscPageHeader,
    AscPageTitle,
    AscAutocompleteSelector,
    AscPreviousNextButtons,
  },

  props: {
    reportDataLoading: {
      type: Boolean,
      default: false,
    },
    reportId: {
      type: Number,
      default: null,
    },
    tailNumber: {
      type: String,
      default: '',
    },
    reportData: {
      type: Array,
      default: () => [],
    },
    timelineData: {
      type: Array,
      default: () => [],
    },
    onReportTimeLineChange: {
      type: Function,
      default: () => {},
    },
    onPreviousReport: {
      type: Function,
      required: true,
    },
    previousDisabled: {
      type: Boolean,
      default: false,
    },
    onNextReport: {
      type: Function,
      required: true,
    },
    nextDisabled: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    getReportHeader() {
      if (this.reportDataLoading || !this.reportData) {
        return ''
      }
      const [first] = this.reportData.filter(item => item.type === 'title')

      let header = `REPORT ${this.reportId} - ${this.tailNumber} - `
      header += first.text ? first.text.toUpperCase() : ''
      return header
    },

    getReportTimeLineItems() {
      return this.timelineData
        .map(item => ({
          text: getDateFormatted(item.timeStamp, 'MMM DD YYYY; HH:mm:ss'),
          value: item.reportId,
        }))
        .sort((a, b) => {
          return new Date(b.text) - new Date(a.text)
        })
    },
  },
}
</script>

<style lang="scss">
.asc-report-header-template {
  &--header {
    display: flex;

    &-title {
      padding-right: 5px;
    }

    @media only screen and (max-width: 900px) {
      display: inline-block;
    }
  }

  .asc-report-time-line-options {
    &.asc-autocomplete-selector {
      width: 200px;
      position: relative;
      top: -4;
    }
  }

  .asc-previous-next-buttons {
    display: flex;
    justify-content: flex-end;
    padding-right: 32px;
  }
}
</style>
